import TemplateList from "template-store/components/template-list/template-list";
import Banner from "template-store/components/banner/banner";
import { withGenericConfig } from "/contexts/generic-config-context";
import MobileTemplatesNavigation from "template-store/components/mobile-navigation/mobile-navigation-component";
import { SEARCH_CONTEXT } from "template-store/constants/template-list-context";
import { HOME_ID } from "template-store/constants/categories";
import { componentStyles } from "./search-page-content.scss";

const SearchPageContent = (props) => {
  const { allCategories, filteredSolutions, translate, translateWithParam, searchTerm, onSearchChange } = props;

  const title = translateWithParam("templateCenter.search.resultsTitle", filteredSolutions.length);

  return (
    <div className="search-page-content-component">
      <div className="banner-wrapper">
        <Banner
          title={translate("templateCenter.homepage.bannerTitle")}
          description={translate("templateCenter.homepage.bannerDescription")}
          titleTagComponent="h1"
          descriptionTagComponent="h3"
        />
      </div>
      <div className="mobile-navigation-wrapper">
        <MobileTemplatesNavigation
          allCategories={allCategories}
          selectedCategoryId={HOME_ID}
          showSearch="true"
          onSearchChange={onSearchChange}
          searchTerm={searchTerm}
          focusOnSearch={true}
        />
      </div>
      <div className="template-list-wrapper">
        <TemplateList title={`${title} "${searchTerm}"`} solutions={filteredSolutions} context={SEARCH_CONTEXT} />
      </div>
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default withGenericConfig(SearchPageContent);
